/* gsw-suche:v1 T-48 Sichtbare Suche: Suchfeld im Kopf öffnet das Horizon-Suchfenster, Messhaken über Shopify.analytics.publish.
 * Keine zweite Suchlogik: Text und Fokus gehen an #cmdk-input, die Vorschläge holt predictive-search.js.
 * dataLayer-Vertrag (Spezifikation T-48, Namen und Felder nicht ändern):
 *   gsw_search_open          search_source: header_field_desktop | header_button_tablet | header_field_mobile | icon
 *   gsw_search_suggest_click search_term, result_type (product, collection, article, page, query, popular, category), result_position
 *   gsw_search_no_results    search_term, search_surface (modal | page)
 * Weg: Shopify.analytics.publish (Custom Pixel, dort läuft GTM). Kein dataLayer-Push im Theme (T-51, 23.10.2026): GTM läuft nur in der Sandbox.
 * Das GA4-Ereignis search sendet das Theme nicht selbst: Shopifys search_submitted von der Ergebnisseite deckt es ab.
 */
(function () {
  if (window.__gswSuche) return;
  window.__gswSuche = true;

  var nextSource = null;
  var pendingField = null;
  var lastNoResults = null;
  var isOpen = false;

  function push(obj) {
    if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
      var name = obj.event;
      var payload = {};
      Object.keys(obj).forEach(function (k) {
        if (k !== 'event') payload[k] = obj[k];
      });
      try {
        Shopify.analytics.publish(name, payload);
      } catch (e) {}
    }
  }

  function modal() {
    return document.getElementById('search-modal');
  }

  function modalInput() {
    return document.getElementById('cmdk-input');
  }

  function canOpen() {
    var m = modal();
    return !!(m && typeof m.showDialog === 'function');
  }

  function fieldSource() {
    // Vertragswerte: ab 990 px Desktopfeld, 750 bis 989 px (Tablet) header_button_tablet, darunter mobil
    if (window.matchMedia('(min-width: 990px)').matches) return 'header_field_desktop';
    if (window.matchMedia('(min-width: 750px)').matches) return 'header_button_tablet';
    return 'header_field_mobile';
  }

  function openModalFrom(field) {
    if (isOpen) return;
    pendingField = field;
    nextSource = fieldSource();
    modal().showDialog();
  }

  /* ---- Suchfeld im Kopf ---- */
  function initBar() {
    // Kürzerer Platzhalter im schmalen Feld (unter 750 px), damit er nicht abgeschnitten wird
    var mq = window.matchMedia('(max-width: 749px)');
    function setPlaceholders() {
      document.querySelectorAll('.gsw-suche-form__input[data-placeholder-lang]').forEach(function (el) {
        el.placeholder = mq.matches
          ? el.getAttribute('data-placeholder-mobil') || el.getAttribute('data-placeholder-lang')
          : el.getAttribute('data-placeholder-lang');
      });
    }
    setPlaceholders();
    if (mq.addEventListener) mq.addEventListener('change', setPlaceholders);
    var forms = document.querySelectorAll('[data-gsw-suche-form]');
    forms.forEach(function (form) {
      // Box statt Eingabefeld (24.10.2026): Klick, Enter und Leertaste auf dem Button lösen "click" aus, das Absenden ohne Fenster bleibt der Weg ohne JavaScript
      var trigger = form.querySelector('[data-gsw-suche-trigger]');
      if (trigger) {
        form.addEventListener('submit', function (event) {
          if (canOpen()) {
            event.preventDefault();
            openModalFrom(null);
          }
        });
        return;
      }
      var field = form.querySelector('input[name="q"][type="search"]');
      if (!field) return;

      // Antippen oder Anklicken öffnet das Fenster (kein Öffnen beim reinen Fokus, WCAG 3.2.1)
      field.addEventListener('click', function () {
        if (canOpen()) openModalFrom(field);
      });

      // Tippen öffnet das Fenster und nimmt den Text mit
      field.addEventListener('input', function () {
        if (canOpen()) openModalFrom(field);
      });

      // Enter im leeren Feld öffnet das Fenster statt eine leere Suche zu senden
      field.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' && !field.value.trim() && canOpen()) {
          event.preventDefault();
          openModalFrom(field);
        }
      });

      form.addEventListener('submit', function (event) {
        if (!field.value.trim() && canOpen()) {
          event.preventDefault();
          openModalFrom(field);
        }
      });
    });
  }

  /* ---- Öffnen: Quelle, Text und Fokus übergeben ---- */
  function onOpen() {
    if (isOpen) return;
    isOpen = true;
    var source = nextSource || 'icon';
    nextSource = null;
    push({ event: 'gsw_search_open', search_source: source });

    var input = modalInput();
    if (!input) return;
    var value = '';
    if (pendingField) {
      value = pendingField.value;
      pendingField.value = '';
      pendingField = null;
    }
    input.focus();
    if (value) {
      input.value = value;
      input.setSelectionRange(value.length, value.length);
      input.dispatchEvent(new InputEvent('input', { bubbles: true, inputType: 'insertText', data: value }));
    }
  }

  function initModal() {
    var m = modal();
    if (!m) return;
    m.addEventListener('dialog:open', onOpen);
    m.addEventListener('dialog:close', function () {
      isOpen = false;
      pendingField = null;
    });

    // Lupen-Knopf im Kopf (nur sichtbar, wenn das Suchfeld ausgeschaltet ist): Quelle icon
    document.addEventListener(
      'click',
      function (event) {
        var btn = event.target.closest && event.target.closest('search-button button');
        if (btn) nextSource = 'icon';
      },
      true
    );

    // Klick auf einen Vorschlag im Fenster
    m.addEventListener(
      'click',
      function (event) {
        var el = event.target.closest && event.target.closest('[data-gsw-type]');
        if (!el) return;
        var all = Array.prototype.slice.call(m.querySelectorAll('[data-gsw-type]'));
        var input = modalInput();
        var inner = m.querySelector('[data-gsw-term]');
        var term = el.getAttribute('data-gsw-term');
        if (term === null) term = (inner && inner.getAttribute('data-gsw-term')) || (input && input.value) || '';
        push({
          event: 'gsw_search_suggest_click',
          search_term: term,
          result_type: el.getAttribute('data-gsw-type'),
          result_position: all.indexOf(el) + 1
        });
      },
      true
    );

    // Ergebnisbereich beobachten: Ansage der Trefferzahl, Knopf-Text, Ereignis "keine Treffer"
    var results = m.querySelector('.predictive-search-form__content');
    if (results) {
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          onResults(m, results);
        });
      }).observe(results, { childList: true, subtree: true });
    }
  }

  function onResults(m, results) {
    var live = m.querySelector('[data-gsw-live]');
    var viewAll = m.querySelector('[ref="viewAllButton"]');
    var inner = results.querySelector('[data-gsw-term]');
    var nr = results.querySelector('[data-gsw-no-results]');
    var term = inner ? inner.getAttribute('data-gsw-term') : '';

    if (nr) {
      var t = nr.getAttribute('data-gsw-no-results');
      if (live) live.textContent = 'Keine Treffer für „' + t + '“.';
      if (lastNoResults !== t) {
        lastNoResults = t;
        push({ event: 'gsw_search_no_results', search_term: t, search_surface: 'modal' });
      }
    } else {
      lastNoResults = null;
      if (live) {
        var n = inner ? parseInt(inner.getAttribute('data-gsw-count'), 10) : NaN;
        live.textContent = !isNaN(n) && n > 0 ? n + ' Treffer für „' + term + '“.' : '';
      }
    }
    if (viewAll) {
      viewAll.textContent = term ? 'Alle Ergebnisse für „' + term + '“ anzeigen' : 'Alle Ergebnisse anzeigen';
    }
  }

  /* ---- 0 Treffer auf der Ergebnisseite ---- */
  function pageNoResults() {
    var el = document.querySelector('[data-gsw-no-results][data-gsw-surface="page"]');
    if (el) {
      push({
        event: 'gsw_search_no_results',
        search_term: el.getAttribute('data-gsw-no-results'),
        search_surface: 'page'
      });
    }
  }

  /* ---- Eine Leiste je Seite: Kopfleiste weicht, solange die Hero-Leiste (Startseite) oder das Feld der Ergebnisseite im Bild ist ---- */
  function initPrimaer() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-gsw-suche-primaer]'));
    var root = document.documentElement;
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      root.setAttribute('data-gsw-primaer', 'an');
      return;
    }
    var seen = new Map();
    function update() {
      var any = false;
      seen.forEach(function (v) {
        if (v) any = true;
      });
      root.setAttribute('data-gsw-primaer', any ? 'an' : 'aus');
    }
    var observer = null;
    function build() {
      if (observer) observer.disconnect();
      var header = document.querySelector('header-component');
      var h = header ? Math.round(header.offsetHeight) : 0;
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            // Ab 750 px (Kopfbox in der Kopfzeile, 24.10.2026): die andere Leiste gilt als im Bild, solange irgendein Teil unter dem Kopf sichtbar ist,
            // sonst stünden Hero-Box und Kopfbox gleichzeitig im Bild. Darunter bleibt die Schwelle 0,5 (mobile Leiste unverändert).
            var need = window.innerWidth >= 750 ? 0 : 0.5;
            seen.set(e.target, e.isIntersecting && e.intersectionRatio > need);
          });
          update();
        },
        { rootMargin: '-' + h + 'px 0px 0px 0px', threshold: [0, 0.5, 1] }
      );
      els.forEach(function (el) {
        // Hero-Section: die sichtbare Box beobachten, nicht die Section samt Polster (24 px unten), sonst bleibt die Hero-Leiste
        // "im Bild", obwohl die Box schon unter der Kopfzeile steckt, und die Kopfbox blendet zu spät ein (Lücke 24.10.2026).
        var target = el.getAttribute('data-gsw-suche-primaer') === 'ab-tablet' ? el.querySelector('.gsw-suche-box') || el : el;
        observer.observe(target);
      });
    }
    build();
    var timer = null;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(build, 200);
    });
    // Kopfzeilenhöhe dynamisch: ändert sie sich (Schrift geladen, Ankündigungsleiste weg), Beobachter mit neuem rootMargin neu aufbauen.
    var hc = document.querySelector('header-component');
    if (hc && 'ResizeObserver' in window) {
      var lastH = Math.round(hc.offsetHeight);
      new ResizeObserver(function () {
        var nh = Math.round(hc.offsetHeight);
        if (nh !== lastH) {
          lastH = nh;
          build();
        }
      }).observe(hc);
    }
  }

  function init() {
    initPrimaer();
    initBar();
    initModal();
    pageNoResults();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
